export default class ChartData {
    constructor($filter, $q) {
        this._filter = $filter;
        this._q = $q;

        this.colorMap = {
            0: 'rgba(228,121,121,1)',
            1: 'rgba(137,130,228,1)',
            2: 'rgba(203,212,79,1)',
            3: 'rgba(84,199,151,1)',
            4: 'rgba(151,187,205,1)',
            5: 'rgba(222,127,202,1)',
            6: 'rgba(228,149,149,1)',
            7: 'rgba(110,177,110,1)',
            8: 'rgba(126,126,138,1)',
            9: 'rgba(121,175,162,1)',
            main: 'rgba(5,204,135,1)'
        };

        this.defaultChardOptions = {
            scaleBeginAtZero: true,
            scaleIntegersOnly: true,
            scaleLineWidth: 1,
            bezierCurve: true,
            datasetStrokeWidth: 3,
            datasetFill: true,
            scaleLabel: '<%= Number(value) %>'
        };

        this.data = {
            labels: [],
            datasets: []
        };
    }

    getColorMap() {
        return this.colorMap;
    };
    
    getDefaultOptions() {
        return this.defaultChardOptions;
    };

    getAllData() {
        return this.data;
    };

    setData(newData) {
        this.data = newData;
    };

    clear() {
        this.data = {
            labels: [],
            datasets: []
        };
    };

    /**
     * Add a line to the statistic chart.
     *
     * @param name Name of the dispatcher
     * @param statistics
     * @param dates Array of startDate and endDate
     * @param color
     * @param hidden
     *
     * @returns Object
     */
    addStatisticsData(name, statistics, dates, color, hidden) {
        let allData = this.getAllData();
        let alphaColor = color.replace(/,1\)/i, ',0.4)');

        allData.datasets.push({
            label: name,
            fillColor: alphaColor,
            strokeColor: color,
            pointColor: color,
            data: [],
            hidden: hidden
        });

        let dataPos = allData.datasets.length - 1;

        if (allData.labels.length == 0) { // Generate labels.
            let startDate = moment(dates.startDate);
            let numLabels = moment(dates.endDate).diff(startDate, 'days') + 1;
            
            if (numLabels == 1) {
                numLabels++;
            }

            for (let labelIter = 0; labelIter < numLabels; labelIter++) {
                allData.labels.push(startDate.format('YYYY-MM-DD'));
                startDate = startDate.add(1, 'day');
            }
        }

        for (var j = 0; j < allData.labels.length; j++) {
            allData.datasets[dataPos].data[j] = 0;
        }

        angular.forEach(statistics, (history) => {
            if (history.created_at == undefined) {
                return;
            }

            let dateLabel = moment(history.created_at).format('YYYY-MM-DD');
            let position = allData.labels.indexOf(dateLabel);

            if (position != -1) { // Label exists -> add count.
                allData.datasets[dataPos].data[position] = history.count;
            }

            if (position - 1 >= 0 && allData.datasets[dataPos].data[position - 1] == null) {
                allData.datasets[dataPos].data[position - 1] = 0;
            }
        });
        
        this.setData(allData);

        return allData;
    };

    netGrowthPerDate(datasetName1, datasetName2, hidden) {
        let allData = this.getAllData();
        let dataSet1, dataSet2, netDiff = [];

        angular.forEach(allData.datasets, (dataset) => {
            if (dataset.label == datasetName1) {
                dataSet1 = dataset.data;
            } else if (dataset.label == datasetName2) {
                dataSet2 = dataset.data;
            }
        });

        for (let i = 0; i < allData.labels.length; i++) {
            netDiff[i] = dataSet1[i] - dataSet2[i];
        }

        allData.datasets.push({
            label: this._filter('translate')('DASHBOARD:NET_GROWTH'),
            fillColor: 'rgba(137,130,228,0.6)',
            strokeColor: 'rgba(137,130,228,1)',
            pointColor: 'rgba(137,130,228,1)',
            data: netDiff,
            hidden: hidden
        });

        this.setData(allData);

        return allData;
    };

    setTileData(data, color) {
        color = color || '#05cc87';

        let tileData = {
            labels: [],
            datasets: [{
                fillColor: color,
                strokeColor: color,
                data: []
            }]
        };

        angular.forEach(data, (dataPoint, key) => {
            tileData.labels.push(moment(key).format('ddd'));
            tileData.datasets[0].data.push(dataPoint.totalCount);
        });
        
        return tileData;
    };

    deviceStatisticsData(deviceStatistics) {
        let totalDevices = {
            labels: [],
            datasets: [{
                fillColor: "RGBA(220,220,220,0.2)",
                strokeColor: "RGBA(52, 184, 128, 0.3)",
                data: []
            }]
        };

        angular.forEach(deviceStatistics, (history) => {
            totalDevices.labels.push(history.name);
            totalDevices.datasets[0].data.push(history.count);
        });

        return totalDevices;
    };
};
